import http from 'axios'

export default {
  getRepartitionTypeExploitationGroupe: (username, codesRegions) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/groupe/repartition/type-exploitation?codesRegions=${codesRegions}`)
  },
  getRepartitionTypeProductionGroupe: (username, codesRegions) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/groupe/repartition/type-production?codesRegions=${codesRegions}`)
  },
  getRepartitionPotentielSolGroupe: (username, codesRegions) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/groupe/repartition/potentiel-sol?codesRegions=${codesRegions}`)
  },
  getRepartitionRessourceEffluentGroupe: (username, codesRegions) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/groupe/repartition/ressource-effluent?codesRegions=${codesRegions}`)
  },
  getRepartitionTypeStockageGroupe: (username, codesRegions) => {
    return http.get(`/web/v1/${username}/parametres-exploitation/groupe/repartition/type-stockage?codesRegions=${codesRegions}`)
  }
}
